<span *ngFor="let tool of tools">
  <span [ngSwitch]="getType(tool)">
    <button *ngSwitchCase="button" [class.active]="tool.isActive" (click)="tool.click()" [disabled]="tool.isDisabled">
      <ion-icon [icon]="tool.icon"></ion-icon>
    </button>
    <app-select-box-tool *ngSwitchCase="selectBox" [item]="toolAsSelectBox(tool)"></app-select-box-tool>
  </span>
</span>
